const createNewProduct = async (selectedProduct) => {
  const response = await fetch('/api/shopify/product/create', {
    method: 'POST',
    body: JSON.stringify(selectedProduct),
  });
  const newProduct = await response.json();
  return newProduct;
};

export default createNewProduct;
